import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  CardBody,
  Modal,
  ModalBody,
  ModalHeader,
  Table,
} from "reactstrap";
import numberToWords from "../../../../../Components/Common/numberToWords";
import { PrintBill } from "../../../BillPrint/page/PrintBill";
import CostCenterService from "../../../../../services/OrderingServices/CostCenterService";
import {
  convertADtoBS,
  formatDateTime,
  formatDatev2,
} from "../../../../../CosmosAdminPages/Appointment/Component/FormatDate";
import html2pdf from "html2pdf.js";

const InvoiceBillModal = ({
  isOpen,
  toggle,
  orgInfo,
  user,
  selectedTable,
  orderId,
  billData,
  calculateTotals,
  responseData,
  selectedCustomer,
}) => {
  console.log("🚀 ~ InvoiceBillModal ~ selectedCustomer:", selectedCustomer)
  console.log("🚀 ~ InvoiceBillModal ~ responseData:", responseData)


  const rawOrder = billData?.[selectedTable?.id];
  const billRef = useRef();

  const handleDownload = () => {
    const element = billRef.current;
    html2pdf()
      .set({
        margin: 0.5,
        filename: `Invoice-${responseData?.invoiceNumber || "Bill"}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "A4", orientation: "portrait" },
      })
      .from(element)
      .save();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        {" "}
        <h5 className="mb-0  fw-bold">✅ Successful Checkout</h5>
      </ModalHeader>
      <ModalBody>
        {/* Title and Actions */}
        <div className="d-flex justify-content-end gap-2 align-items-center mb-3">
          <button
            className="btn btn-light  btn-sm"
            title="Download"
            onClick={handleDownload}
          >
            <i className="ri-download-2-line "></i>
          </button>
          <PrintBill
            currentOrder={rawOrder}
            orgInfo={orgInfo}
            user={user}
            orderId={orderId}
            calculateTotals={calculateTotals}
            responseData={responseData}
            isestimateprint={false}
            selectedCustomer={selectedCustomer}
          />
        </div>
        <div ref={billRef}>
          <Card className="shadow-sm border-0 rounded-3">
            <CardBody
              className="d-flex flex-column p-3"
              style={{ fontFamily: "monospace", fontSize: "14px" }}
            >
              {/* Header */}
              <div className="text-center mb-2">
                <h5 className="fw-bold text-uppercase mb-0">
                  {orgInfo?.name || "Company Name"}
                </h5>
                <div className="text-uppercase">{orgInfo?.address1 || ""}</div>
                <div>{orgInfo?.tel || "000-0000000"}</div>
                <div className="fw-bold mt-1">INVOICE</div>
              </div>

              {/* Info Rows */}
              <div className="d-flex justify-content-between small mb-1">
                <div>
                  <strong>PAN No.:</strong> {orgInfo?.pan || "..."}
                </div>
                <div>
                  <strong>Copy of:</strong> Original
                </div>
              </div>
              <div className="d-flex justify-content-between small mb-1">
                <div>
                  <strong>Customer:</strong>{" "}
                  {selectedCustomer
                    ? `${selectedCustomer.firstName} ${selectedCustomer.lastName}`
                    : "...."}
                </div>
                <div>
                  <strong>PAN:</strong> {"..."}
                </div>
              </div>
              <div className="d-flex justify-content-between small mb-1">
                <div>
                  <strong>Phone No.:</strong>{" "}
                  {selectedCustomer?.phoneNo || "...."}
                </div>
                <div>
                  <strong>Cashier:</strong> {"..."}
                </div>
              </div>
              <div className="d-flex justify-content-between small mb-1">
                <div>
                  <strong>Address:</strong>{" "}
                  {selectedCustomer?.address || "...."}
                </div>
                <div>
                  <strong>INV No:</strong>{" "}
                  {responseData?.invoiceNumber || "..."}
                </div>
              </div>
              <div className="d-flex justify-content-between small mb-2">
                {/* <div>
                <strong>Date (B.S.):</strong>  {convertADtoBS(responseData?.billDate)}
              </div> */}
                <div>
                  <strong>Date (A.D.):</strong>{" "}
                  {formatDatev2(responseData?.billDate)}
                </div>
              </div>
              <div className="d-flex justify-content-between small mb-2">
                <div>
                  <strong>Table ID:</strong> {responseData?.orderSummary?.tableId || "T-1"}
                </div>
                <div>
                  <strong>Time:</strong>{" "}
                  {new Date().toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </div>
              </div>

              {/* Table */}
              <Table size="sm" responsive className="table-bordered small mb-0">
                <thead>
                  <tr>
                    <th>SN</th>
                    <th>Item</th>
                    <th className="text-center">Qty</th>
                    <th className="text-center">Rate</th>
                    <th className="text-end">Amnt</th>
                  </tr>
                </thead>
                <tbody>
                  {responseData &&
                    responseData?.orderSummary?.orderDetails?.map(
                      (item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.productName}</td>
                          <td className="text-center">{item.finalQuantity}</td>
                          <td className="text-center">
                            {item?.productPrice.toFixed(2)}
                          </td>
                          <td className="text-end">
                            {(item?.totalPrice).toFixed(2)}
                          </td>
                        </tr>
                      )
                    )}
                </tbody>
              </Table>

              {/* Totals */}
              <div className="border-top pt-2 small">
                <div className="d-flex justify-content-between">
                  <div>Total Qty:</div>
                  <div>
                    {rawOrder?.items.reduce((a, b) => a + b.quantity, 0)}
                  </div>
                </div>
                <div className="d-flex justify-content-between">
                  <div>Sub Total:</div>
                  <div>Rs. {responseData?.totalAmount.toFixed(2)}</div>
                </div>
                <div className="d-flex justify-content-between">
                  <div>Discount Amount:</div>
                  <div>Rs. {responseData?.discountAmount.toFixed(2)}</div>
                </div>
                <div className="d-flex justify-content-between">
                  <div>Tax Amount:</div>
                  <div>Rs. {responseData?.taxAmount.toFixed(2)}</div>
                </div>
                <div className="d-flex justify-content-between fw-bold">
                  <div>Grand Total Amount:</div>
                  <div>Rs. {responseData?.grandTotal.toFixed(2)}</div>
                </div>
                <div className="mt-2">
                  <div>
                    <strong>In Words:</strong>{" "}
                    {numberToWords(responseData?.grandTotal)} Rupees
                  </div>
                </div>
              </div>

              {/* Footer Info */}
              <div className="small mt-2">
                <div>Printed On: {new Date().toLocaleString()}</div>
                <div className="text-center mt-2">**Thank You**</div>
                <div className="text-center text-muted small">
                  Powered by Restro Order
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default InvoiceBillModal;
